import * as types from '../actions/actionTypes';
import {getFeatureGroupFeaturesQuantity} from "../bvcomponents/look/lookNavigation/lookNavigationFunctions";

const initialState = {
  filtersOpened: false,
  similarFeature: null,
  similarProductsOpened: false,
  requiredButNotIncludedFeature: null,
  groheFiltersSearchText: "",
  lastOpenedFeature: null,
  lastOpenedCategory: null,
  subCategoryOpened: "",
  showAddedToTheCartSuccess: false,
  groheActiveFeatureQuantity: 1,
  groheShareButtonsOpened: false,
  groheSameColorActiveFeature: null,
  groheSameColorSectionOpened: false,
  groheSameColorCheckboxApplied: false,
  exisingTempId: "",
};

export default function(state = initialState, action){
  switch (action.type) {
    case types.SET_GROHE_FILTERS_OPENED:
    case types.SET_GROHE_SIMILAR_FEATURE:
    case types.SET_GROHE_SIMILAR_PRODUCTS_OPENED:
    case types.SET_GROHE_REQUIRED_BUT_NOT_INCLUDED_FEATURE:
    case types.SET_GROHE_FILTERS_SEARCH_TEXT:
    case types.SET_GROHE_LAST_OPENED_CATEGORY:
    case types.SET_GROHE_SUB_CATEGORY_OPENED:
    case types.SET_GROHE_SHOW_ADDED_TO_THE_CART_SUCCESS:
    case types.SET_GROHE_ACTIVE_FEATURE_QUANTITY:
    case types.SET_GROHE_SHARE_BUTTONS_OPENED:
    case types.SET_GROHE_SAME_COLOR_SECTION_OPENED:
    case types.SET_GROHE_SAME_COLOR_CHECKBOX_APPLIED:
    case types.SET_GROHE_SAME_COLOR_ACTIVE_FEATURE:
    case types.SET_GROHE_EXISTING_TEMP_ID:
      return Object.assign({}, state, {
        ...action.payload
      });
    case types.SET_LOOK_ACTIVE_FEATURE: {
      return Object.assign({}, state, {
        lastOpenedFeature: action.payload.lookActiveFeature || state.lastOpenedFeature,
        subCategoryOpened: action.payload.lookActiveFeature ? "" : state.subCategoryOpened,
        groheActiveFeatureQuantity: getFeatureGroupFeaturesQuantity(action.payload.lookActiveFeature),
      });
    }
    case types.SET_LOOK_ACTIVE_CATEGORY: {
      return Object.assign({}, state, {
        lastOpenedCategory: action.payload.lookActiveCategory || state.lastOpenedCategory,
        filtersOpened: !action.payload.lookActiveCategory && state.filtersOpened ? false : state.filtersOpened,
        groheFiltersSearchText: !action.payload.lookActiveCategory && state.groheFiltersSearchText ? "" : state.groheFiltersSearchText,  // always remove it on open/close
      });
    }
    case types.SET_LOOK_OPENED: {
      return Object.assign({}, state, {
        lastOpenedFeature: (!action.payload.lookOpened && state.lastOpenedFeature) ? null : state.lastOpenedFeature,
        lastOpenedCategory: (!action.payload.lookOpened && state.lastOpenedCategory) ? null : state.lastOpenedCategory,
        subCategoryOpened: "", // always remove it on open/close
        similarProductsOpened: false,  // always remove it on open/close
        requiredButNotIncludedFeature: null,  // always remove it on open/close
        groheActiveFeatureQuantity: !action.payload.lookOpened ? 1 : state.groheActiveFeatureQuantity,
        groheFiltersSearchText: "",  // always remove it on open/close
      });
    }
    case types.SET_LOOK_PAGE_OPENED: {
      return Object.assign({}, state, {
        groheSameColorActiveFeature: (action.payload.lookPageOpened && state.groheSameColorActiveFeature) ? null : state.groheSameColorActiveFeature,
      });
    }
    case types.SET_WIZARD_ACTIVE_ITEM: {
      return Object.assign({}, state, {
        subCategoryOpened: "",
        groheFiltersSearchText: "",  // always remove it on open/close
      });
    }
    case types.SET_WIZARD_ACTIVE_STEP: {
      if (state.groheFiltersSearchText) {
        return Object.assign({}, state, {
          groheFiltersSearchText: "",  // always remove it on step change
        });
      }
    }
  }
  return state;
}
